/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
    withRouter
} from 'react-router-dom';
/* Package JSON Import will be here */
/* Project Import will be here */
import EquipmentListComponent from './equipmentList.component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/login.Action';

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class EquipmentListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            equipmentListDataList: [],
            isOpenModel: false,
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedValue: {},
            isEditEquipmentList: false,
            equipmentlistNameSearch: "",
            isSetButtonDisabled: false,
            isDeleteConfiram: false,
            selectedIdForDelete: ""
        };
    }

    componentDidMount() {
        this.getEquipmentList();
    }

    getEquipmentListDetails(equipmentListId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.GT_EQMT_M}?equipmentId=${equipmentListId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    selectedValue.equipmentListName = responseData.data.displayText;
                    selectedValue.equipmentListId = responseData.data.id;
                    this.setState({
                        selectedValue, isEditEquipmentList: true
                    });
                }
            }
        });
    }

    getEquipmentList() {
        let { equipmentlistNameSearch, pagination } = this.state;
        let searchArray = [];
        if (equipmentlistNameSearch) {
            let searchObj = {
                FieldName: Constants.EQUIPMENT_LIST_SEARCH,
                Value: equipmentlistNameSearch
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.GT_EQMT_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    this.setState({
                        equipmentListDataList: responseData.data,
                        pagination
                    });
                }
                else {
                    this.setState({
                        equipmentListDataList: []
                    });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getEquipmentList();
        });
    }

    onEquipmentListSearch = event => {
        this.setState({ equipmentlistNameSearch: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getEquipmentList();
        });
    }

    handleEquipmentListChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.equipmentListName = value;
        this.setState({ selectedValue });
    }

    onOpenModel = equipmentListDetails => {
        if (equipmentListDetails.equipmentListId) {
            this.getEquipmentListDetails(equipmentListDetails.equipmentListId);
        }
        this.setState({
            isOpenModel: true,
            selectedValue: {},
        });
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditEquipmentList: false, selectedValue: {} }, () => this.getEquipmentList());
    }

    onSaveEquipmentList(equipmentListId = null) {
        let { selectedValue, isEditEquipmentList } = this.state;
        this.setState({ isSetButtonDisabled: true });
        if (!selectedValue.equipmentListName || !selectedValue.equipmentListName.trim()) {
            MessageBox(Constants.PLEASE_ENTER_EQUIPMENT_NAME, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
     
        let requestData = {
            Id: selectedValue.equipmentListId,
            DisplayText: selectedValue.equipmentListName.trim(),
        }

        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.SV_EQMT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                this.setState({ isSetButtonDisabled: false });
            }
            if (responseData.success) {
                this.onCloseModel();
            }
        });
    }

    onDeleteEquipmentList = (equipmentListDetails) => {
        this.setState({ isDeleteConfiram: true, selectedIdForDelete: equipmentListDetails.equipmentListId });
    }
    onCancelDelete = () => {
        this.setState({ isDeleteConfiram: false, selectedValue: {} })
    }
    onConfirmDelete = () => {
        let { selectedIdForDelete } = this.state;
        let url = `${ApiUrls.Routes.EQMT_C}${ApiUrls.Routes.DLT_EQMT_M}?equipmentId=${selectedIdForDelete}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData.success) {
                this.setState({ isDeleteConfiram: false, selectedValue: {} }, () => {
                    var apage = Math.ceil(this.state.equipmentListDataList.length - 1 === 0 && this.state.pagination.totalCount !== 1 ? (this.state.pagination.totalCount - 1) : this.state.pagination.totalCount);
                    this.onPageChange(null, { activePage: this.state.pagination.activePage > apage ? apage : this.state.pagination.activePage });
                });
            }
            MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
        });
    }

    render() {
        const { equipmentListDataList, isEditEquipmentList, isSetButtonDisabled, groupAccess,
            Division, selectedValue, group, isOpenModel, pagination, isDeleteConfiram } = this.state;
        return (
            <Fragment>
                <EquipmentListComponent
                    {...{
                        equipmentList: {
                            equipmentListDataList,
                            isOpenModel,
                            pagination,
                            groupAccess,
                            Division,
                            group,
                            selectedValue,
                            isEditEquipmentList,
                            isSetButtonDisabled,
                            isDeleteConfiram,
                        }
                    }}
                    onOpenModel              = {this.onOpenModel.bind(this)}
                    onCloseModel             = {this.onCloseModel.bind(this)}
                    onSaveEquipmentList      = {this.onSaveEquipmentList.bind(this)}
                    onEquipmentListSearch    = {this.onEquipmentListSearch.bind(this)}
                    handleEquipmentListChange= {this.handleEquipmentListChange.bind(this)}
                    onPageChange             = {this.onPageChange.bind(this)}
                    user                     = {this.props.user}
                    onCancelDelete           = {this.onCancelDelete.bind(this)}
                    onDeleteEquipmentList    = {this.onDeleteEquipmentList.bind(this)}
                    onConfirmDelete          = {this.onConfirmDelete.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EquipmentListPage));
EquipmentListPage.displayName = 'EquipmentListPage';